import React from "react";
import { IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import {
  FIRE_SAFETY_CONSUMER,
  fireSafetyScheduleStatusTypes,
} from "common/constant";

const CustomEvent = ({
  event: { id, title, type, status },
  deleteBtnHandler,
  buildingName,
}) => {
  const { roles } = useSelector((state) => state.Login);

  return (
    <div className="d-flex justify-content-between">
      <Typography
        sx={{
          width: "90%",
          overflow: "hidden",
          textOverflow: "ellipsis",
        }}
      >
        {title}
      </Typography>
      {!roles.includes(FIRE_SAFETY_CONSUMER) &&
        type !== "consumer" &&
        status !== fireSafetyScheduleStatusTypes["Completed"] &&
        title !== buildingName && (
          <IconButton
            size="small"
            sx={{
              height: "14px",
              width: "14px",
              marginTop: "6px",
              marginRight: "5px",
            }}
            onClick={() => deleteBtnHandler(id, type)}
          >
            <CloseIcon />
          </IconButton>
        )}
    </div>
  );
};

CustomEvent.propTypes = {
  deleteBtnHandler: PropTypes.func,
  event: PropTypes.object,
  buildingName: PropTypes.string,
};

export default CustomEvent;
